import {
    AccountInfo,
    EventType,
    IPublicClientApplication,
    PublicClientApplication,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { ReactNode, useEffect } from 'react';

import { createMark, PerformanceMarkName } from '../hooks/usePerformance';
import msalConfig from '../utilities/msal/msal.config';

interface Props {
    children: ReactNode;
}

const instance: IPublicClientApplication = new PublicClientApplication(msalConfig);

/**
 * Initializes Msal
 */
export default function MsalAuthenticationProvider({ children }: Props) {
    createMark(PerformanceMarkName.LoginStart);
    // Select the first B2C account after login
    useEffect(() => {
        const callBackId = instance.addEventCallback(
            (event: { eventType: EventType; payload: { account: AccountInfo } }) => {
                if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                    const account = event.payload.account;
                    instance.setActiveAccount(account);
                }
            }
        );

        return () => {
            if (callBackId) {
                instance.removeEventCallback(callBackId);
            }
        };
    }, []);

    return <MsalProvider instance={instance}>{children}</MsalProvider>;
}
